import { Component, OnInit } from '@angular/core';
import { ProgressSpinnerMode, ThemePalette } from '@angular/material';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';
import { MatDialog } from '@angular/material/dialog';
import { ByProductGatepassBillingPreviewComponent } from '../by-product-gatepass-billing-preview/by-product-gatepass-billing-preview.component';

@Component({
  selector: 'app-by-product-return-gatepass',
  templateUrl: './by-product-return-gatepass.component.html',
  styleUrls: ['./by-product-return-gatepass.component.scss']
})
export class ByProductReturnGatepassComponent implements OnInit {
  selected_employee_code = null;
  selected_booth_code = null;
  is_data_available = true;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  title = '';
  by_product_order_list: any = [];
  show_grn_page = false;
  selected_product_list = [];
  grn_number = null;
  grn_date: any = new Date().toISOString().split('T')[0];
  selected_sale_group_id: any = null;

  constructor(private globalService: GlobalService, private httpService: HttpService, private dialog: MatDialog) { 
    this.title = this.globalService._active_display_name;
   }

  serveEmployeeOrder() {
    let data_dict = {
      'business_code': this.selected_employee_code
    };
    this.is_data_available = false;
    this.httpService.serveByProductOrderForEmployee(data_dict).subscribe((data) => {
      console.log(data);
      this.by_product_order_list = data;
      this.is_data_available = true;
    }, (error) => {
      this.is_data_available = true;
      console.error(error);
    });
  }


  serveGrnNumber() {
    this.httpService.serveGoodsGRNNumber().subscribe(
      (data) => {
        console.log(data);
        this.grn_number = data;
      },
      (error) => {
        console.error(error);
      }
    );
  }

  generateBillCalled (order_data) {
    this.selected_sale_group_id = order_data['by_sale_group_id'];
    this.selected_booth_code = order_data['business_code']
    let data_dict = {
      'sale_group_id': this.selected_sale_group_id 
    }
    this.httpService.serveGoodsProductRecordForEmployeeOrder(data_dict).subscribe((data: any) => {
      console.log(data);
      this.selected_product_list = data
      this.confirmClicked();
    }, (error) => {
      console.error(error);
    });
  }

  confirmClicked() {
    console.log(this.selected_product_list);
    let data_dict = {
      'by_sale_group_id': this.selected_sale_group_id,
      'product_list': this.selected_product_list,
      'business_code': this.selected_booth_code
    }
    this.httpService.serveBillingPreview(data_dict).subscribe((data) => {
      console.log(data);
      const dialogRef = this.dialog.open(ByProductGatepassBillingPreviewComponent, {
        height: '394px',
        width: '600px',
        data: {
          'by_sale_group_id': this.selected_sale_group_id,
          'product_data': data,
          'business_code': this.selected_booth_code,
          'return_product_list': this.selected_product_list
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
        const res = result;
        if (res) {
          this.serveEmployeeOrder();
          this.enableProductList();
        }
      });
    }, (error) => {
      console.error(error);
    });
  }


  productQuantityChanged(product_index) {
    const numbers = /^[0-9\s]*$/;
    let product_dict = this.selected_product_list[product_index];
    let ordered_qty = product_dict['count'];
    if (product_dict['return_qty'] > ordered_qty) {
      alert('Product Qty Exceed With Order!');
      this.selected_product_list[product_index]['return_qty'] = null;
    }
    if (product_dict['return_qty'] != null) {
      if (numbers.test(product_dict['return_qty']) === false) {
        alert('Invalid Number');
        this.selected_product_list[product_index]['return_qty'] = null;
      }
    }
    this.selected_product_list[product_index]['billing_qty'] = 0
    let billing_qty = product_dict['count'] - product_dict['return_qty'];
    this.selected_product_list[product_index]['billing_qty'] = billing_qty

  }

  enableProductList() {
    this.show_grn_page = false;
    this.selected_booth_code = null;
    this.selected_product_list = [];
    this.selected_sale_group_id = null;
  }

  returnGRNCalled(order_data) {
    // this.selected_product_list = order_data['product_list'];
    this.selected_sale_group_id = order_data['by_sale_group_id'];
    this.selected_booth_code = order_data['business_code']
    this.show_grn_page = true;
    let data_dict = {
      'sale_group_id': this.selected_sale_group_id 
    }
    this.httpService.serveGoodsProductRecordForEmployeeOrder(data_dict).subscribe((data: any) => {
      console.log(data);
      this.selected_product_list = data;
      window.scrollTo(0, 0);
    }, (error) => {
      console.error(error);
    });
  }

  ngOnInit() {
  }

}
